import React from 'react'
import Button from './ui/Button'

export default function Banner() {
    return (
        <div className='banner bg-grey'>
            <div className="py-6">
                <h1 className='banner-h1'>LJ:S PLÅTSLAGERI AB</h1>
            </div>
            <div className='banner-content justify-content-center justify-content-md-between px-lg-6 px-4'>
                <div>
                    <p className='banner-p'>Ett plåtslageri verksamt i Linköping med omnejd. Utför allt inom byggnadsplåt🤘
                    </p>
                </div>
                <Button text={'Kontakta oss'} link={'kontakt'} />
            </div>
        </div>
    )
}